export default __webpack_public_path__ + "static/media/two.ea24bc35.png";